<!-- 
程式：RelationManage.vue
功能：待歸戶清單
作者：i9400539 鄧啓擇
完成：2020-07-30
-->
<template>
  <main
    :class="mvAddFamilyOpen ? '' : 'body-container'"
    :style="isBox ? 'top: 0px;' : ''"
    :key="reloadKey"
  >
    <section class="search container" style="padding: 20px 0">
      <div class="row">
        <div class="col-8 col-md-7 col-sm-7 offset-1">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證、保單號碼或手機進行搜尋..."
                  alt="ch"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
        <div class="col-2 col-md-3 col-sm-4 text-center">
          <a class="btn btn-default btn_style" @click.prevent="toAllHolder()"
            >返回戶長列表</a
          >
        </div>
      </div>
    </section>
    <section class="container-fluid">
      <div
        class="radio radio-inline"
        style="margin-left: 10px; margin-bottom: 10px"
      >
        <input
          type="radio"
          v-model="isRelate"
          name="switchType"
          id="isRelate-P"
          value="P"
        />
        <label for="isRelate-P"
          >尚未歸戶(壽險經手/收費件)({{ noFamilyhavePolicyList.length }})</label
        >
      </div>
      <div class="radio radio-inline">
        <input
          type="radio"
          v-model="isRelate"
          name="switchType"
          id="isRelate-N"
          value="N"
        />
        <label for="isRelate-N"
          >尚未歸戶(非壽險經手/收費件)({{ noFamilyList.length }})</label
        >
      </div>
      <div class="radio radio-inline">
        <input
          type="radio"
          v-model="isRelate"
          name="switchType"
          id="isRelate-Y"
          value="Y"
        />
        <label for="isRelate-Y">所有客戶({{ allCustomersList.length }})</label>
      </div>
    </section>
    <div class="container-fluid" style="margin-bottom: 130px">
      <div class="row">
        <data-table
          style="width: 78rem"
          @update="updateSelection"
          :selection="selection"
          :currentPage="paginate.page"
          :table-data="tableData"
          :options="tableOption"
          :initSort="initSort"
          :remote-data-msg="remoteDataMsg"
          :addPageStatus="addPageStatus"
          :scroll-data-loading="scrollDataLoading"
          :scroll-message-loading="scrollMessageLoading"
          :isMask="true"
          :saveData="saveData"
          ref="dataTable"
        />
      </div>
    </div>

    <fixed-botton ref="fixedBtn">
      <template slot="@function">
        <button
          @click="submit()"
          type="button"
          class="btn btn-primary bottom_btn_style"
          :disabled="selection ? !selection.length : true"
        >
          歸戶
        </button>
      </template>
    </fixed-botton>
    <mv-add-family-modal
      :open="mvAddFamilyOpen"
      @close="panelClose('mvAddFamilyOpen')"
      @confirm="panelOpen('mvAddFamilyOpen')"
    />
  </main>
</template>

<script>
import DataTable from "../components/DataTable/DataTableScroll";
import FixedBotton from "../components/modal/fixedBotton";
import { mapActions } from "vuex";
import { queryRelationList } from "@/service";
import { commonMixin } from "@/mixins/common";
import MvAddFamilyModal from "@/desktop/views/mv/components/mvAddFamilyModal";
import CustomerDetail1BackOriginMainScrollTopMixins from "@/mixins/CustomerDetail1BackOriginMainScrollTop";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";

const { $, _ } = window;
export default {
  name: "RelationManage",
  components: {
    DataTable,
    FixedBotton,
    MvAddFamilyModal,
  },
  mixins: [
    commonMixin,
    CustomerDetail1BackOriginMainScrollTopMixins,
    RouteToCustDetailMixins,
  ],
  data() {
    const querySort = {
      order_by: this.$route.query.order_by || "5",
      colName: this.$route.query.colName || "address",
      isSort:
        this.$route.query.isSort == "true" || this.$route.query.isSort == true
          ? true
          : false,
    };
    return {
      mvAddFamilyOpen: false, // 歸戶Modal
      tableData: [], // 查詢結果
      selection: [], // 勾選項目
      allCustomersList: [], //所有客戶
      noFamilyList: [], //尚未歸戶客戶(所有)
      noFamilyhavePolicyList: [], //尚未歸戶客戶(經手/服務件客戶)
      paginate: {
        page: 0, //當前頁數
        perPage: 200,
        total: {
          all: 0, //所有客戶總頁數
          no: 0, //尚未歸戶總頁數
        },
      },
      isLoading: false, // 避免重複查詢
      addPageStatus: false,
      scrollMessageLoading: false,
      scrollDataLoading: false,
      remoteDataMsg: "資料讀取中，請稍候...", //讀取訊息
      isRelate: this.$route.query.isRelate || "P", //是否歸戶
      keyword: this.$route.query.keyword || "", //關鍵字搜尋
      order: {
        order_by_default: "5", // 預設：住家地址
        order_asc_default: false, // 預設：大到小
        order_by: "5",
        order_asc: false,
      },
      querySort,
      initSort: false,
      isPageBack: false,
      tableOption: {
        showAge: true,
        checkAll: true,
        checkList: true,
        scrollHeight: 350,
        noScroll: false,
        isScrollLoading: true,
        checkBoxHasUser: true,
        truncate: true,
        columnSortScrollReset: true,
        columns: [
          {
            width: 110,
            name: "name",
            label: "姓名",
            sorting: true,
            click: (data) => {
              this.routeToCustDetail2(data.id, data.ser_no, data.name);
            },
            savePageData: true,
          },
          {
            width: 120,
            name: "mobile",
            label: "手機",
            sorting: true,
          },
          {
            width: 130,
            name: "phone",
            label: "電話",
            sorting: true,
          },
          {
            width: 100,
            name: "birthday",
            label: "生日",
            sorting: true,
          },
          {
            name: "address",
            sorting: true,
            label: "住家地址",
          },
          {
            width: 101,
            name: "search",
            label: "要保人<br>被保人",
            sorting: true,
            click: (data) => {
              this.toPolicyRelation(data.id, data.name);
            },
            savePageData: true,
          },
          {
            width: 101,
            name: "family_name",
            sorting: true,
            label: "戶長",
            click: (data) => {
              this.routeToCustDetail2(
                data.family_id,
                data.family_id,
                data.family_name
              );
            },
            savePageData: true,
          },
        ],
        // 排序
        defaultSort: {
          colName: querySort.colName,
          asc: querySort.isSort,
          doSort: false,
        },
        scrollLoadingAPI: (page) => {
          if (page) {
            this.paginate.page = page;
            this.addList(this.showDatas, true);
          } else {
            this.paginate.page = this.paginate.page + 1;
            this.addList(this.showDatas);
          }
        },
        sorting: this.changeSort,
      }, // table參數
      reloadKey: 0,
      saveData: false,
      clearSaveData: false,
    };
  },
  watch: {
    isRelate() {
      this.paginate.page = 0;
      this.tableData = this.sliceData(this.showDatas);
      this.$router.assignQuery({
        isRelate: this.isRelate,
      });
      this.$refs.dataTable.clearSaveData();
      this.reload();
      this.$nextTick(this.registerHanlink);
    },
    showDatas() {
      if (window._.isEmpty(this.showDatas)) {
        this.remoteDataMsg = "查無資料";
      }
    },
  },
  methods: {
    ...mapActions([
      "updateFamilyResultFilter",
      "updateLastFamilyResult",
      "updateUserItems",
    ]),
    reload() {
      this.reloadKey++;
    },
    updateSelection(val) {
      this.selection = val;
    },

    // 送出 TODO
    submit() {
      // 檢核家戶既有人數+重新歸戶加入的人數 不得超過50人+
      if (this.selection.length > 50) {
        this.$toast.info({ title: "家戶成員不得超過50人+" });
        return;
      }
      this.setHistory("joinFamily", "addToFamily");
      this.updateLastFamilyResult([]);
      this.updateFamilyResultFilter(
        this.selection.map((x) => ({ ...x, csidno: x.id || x.ser_no }))
      );
      this.panelOpen("mvAddFamilyOpen");
    },

    cleanSearch() {
      this.keyword = "";
      this.doSearch();
    },

    //查詢
    doSearch() {
      this.saveData = false;

      if (!this.$store.state.compositionStatus) {
        this.remoteDataMsg = "資料讀取中，請稍候...";
        this.tableData = [];

        this.initSort = true;
        this.order.order_by = this.order.order_by_default;
        this.order.order_asc = this.order.order_asc_default;

        this.getCustomersList(this.$store.state.userInfo.id, this.keyword);
      }
    },
    // 取得客戶列表
    getCustomersList(agntId, keyword) {
      return new Promise((resolve) => {
        if (this.$router.history.current.query["keyword"] != keyword) {
          this.$router.assignQuery({ keyword });
        }
        this.addPageStatus = true;
        if (this.isLoading) {
          return;
        }

        this.paginate.page = 0;
        const order_by = this.order.order_by;
        const order_asc = this.order.order_asc === true ? "1" : "2";
        this.isLoading = true;
        queryRelationList(
          agntId,
          keyword,
          "1",
          "1",
          "1",
          "1",
          "1",
          "1",
          order_by,
          order_asc
        ).then((result) => {
          this.allCustomersList = result.body.allCustomersList || []; //所有客戶清單
          const allNoFamily = result.body.noFamilyList || [];
          this.noFamilyList = allNoFamily.filter((x) => !x.havePolicy) || []; //尚未歸戶(非經手/收費件)
          this.noFamilyhavePolicyList =
            allNoFamily.filter((x) => x.havePolicy) || []; //尚未歸戶(經手/收費件)

          this.paginate.total.all = Math.floor(
            this.allCustomersList.length / this.paginate.perPage
          ); //所有客戶總頁數
          this.paginate.total.no = Math.floor(
            allNoFamily.length / this.paginate.perPage
          ); //尚未歸戶總頁數

          this.tableData = this.sliceData(this.showDatas);

          this.isLoading = false;
          this.addPageStatus = false;

          if (!allNoFamily.length) {
            this.remoteDataMsg = keyword
              ? "查無資料，請確認您輸入之資料是否正確"
              : "您已將所有客戶完成歸戶";
          }

          if (this.initSort) {
            this.initSort = false;
          }

          resolve();
        });
      });
    },
    // 增加畫面顯示資料
    addList(data, isSelectPage) {
      this.addPageStatus = true;
      if (isSelectPage) {
        this.tableData = this.sliceData(data, isSelectPage);
      } else {
        this.tableData = this.tableData.concat(this.sliceData(data));
      }
      /*  setTimeout(() => {
        this.addPageStatus = false;
        this.scrollMessageLoading = false;
        this.scrollDataLoading = false;
      }, 200);
    */
    },

    // 切分頁
    sliceData(data, isSelectPage) {
      if (isSelectPage) {
        return data.slice(0, (this.paginate.page + 1) * this.paginate.perPage);
      }
      return data.slice(
        this.paginate.page * this.paginate.perPage,
        (this.paginate.page + 1) * this.paginate.perPage
      );
    },
    // go search relate policy
    toPolicyRelation(id, name) {
      let vThis = this;
      this.$router.push({
        name: "policyRelation",
        params: { id, name, routeQuery: vThis.$route.query },
      });
    },
    // 返回戶長列表
    toAllHolder() {
      this.$router.push({ name: "allHolder" });
    },
    changeSort(order_by, colName, isSort) {
      this.querySort = {
        order_by,
        colName,
        isSort,
      };

      this.$router.assignQuery({
        ...this.querySort,
      });
      this.remoteDataMsg = "資料讀取中，請稍候...";
      this.tableData = [];

      this.order.order_asc = isSort;
      if (["name", "address", "family_name"].includes(colName)) {
        // 因為呼叫api MXCL_0001 已經定義好數字，故強制跟換編號
        const map = {
          // 姓名
          1: 2,
          // 手機
          2: 4,
          // 電話
          3: 5,
          // 生日
          4: 6,
          // 住家地址
          5: 7,
          // 要保人/被保人
          6: "",
          // 戶長
          7: "family_name",
        };
        this.order.order_by = map[order_by];
        this.getCustomersList(this.$store.state.userInfo.id, this.keyword);
      } else {
        const orderByKeys =
          colName == "search"
            ? [(x) => (x.id && x.havePolicy ? "1" : "")]
            : [colName];

        const orderByTypes = [isSort ? "asc" : "desc"];
        let orderBy = (keys, types) => (datas) => _.orderBy(datas, keys, types);
        if (this.isRelate == "Y") {
          this.allCustomersList = orderBy(
            orderByKeys,
            orderByTypes
          )(this.allCustomersList);
        } else if (this.isRelate == "N") {
          this.noFamilyList = orderBy(
            orderByKeys,
            orderByTypes
          )(this.noFamilyList);
        } else if (this.isRelate == "P") {
          this.noFamilyhavePolicyList = orderBy(
            orderByKeys,
            orderByTypes
          )(this.noFamilyhavePolicyList);
        }
        this.tableData = this.sliceData(
          orderBy(orderByKeys, orderByTypes)(this.showDatas),
          true
        );
      }
    },
  },
  computed: {
    showDatas() {
      if (this.isRelate == "Y") {
        return this.allCustomersList;
      } else if (this.isRelate == "N") {
        return this.noFamilyList;
      } else if (this.isRelate == "P") {
        return this.noFamilyhavePolicyList;
      }
    },
    scrollHeight() {
      let reducePx = window.screen.height >= 1024 ? 435 : 535;
      return window.screen.height - reducePx;
    },
    isBox() {
      //判斷是否為box   this.UserInfo.userType === 'box'
      return this.UserInfo.userType === "box";
    },
  },
  async mounted() {
    this.tableOption.scrollHeight =
      $(window).height() - 435 < 390 ? 390 : $(window).height() - 435;
    let self = this;

    $(window).on("resize", function () {
      self.$nextTick(() => {
        self.tableOption.scrollHeight =
          $(window).height() - 435 < 390 ? 390 : $(window).height() - 435;
      });
    });

    if (!["name", "address", "family_name"].includes(this.querySort.colName)) {
      await this.getCustomersList(this.$store.state.userInfo.id, this.keyword);
    }
    this.changeSort(
      this.querySort.order_by,
      this.querySort.colName,
      this.querySort.isSort
    );
    this.updateUserItems({});
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "customer-detail-1" || from.name === "policyRelation") {
        vm.saveData = true;
        vm.isPageBack = true;
      } else {
        vm.$refs.dataTable.clearSaveData();
      }
    });
  },
};
</script>

<style scoped>
.disableClass + label:before {
  border-color: lightgray !important;
}

.disableClass + label:after {
  content: "" !important;
  position: absolute !important;
  display: block !important;
  width: 10px !important;
  height: 10px !important;
  left: 5px !important;
  top: 0px !important;
  bottom: 0 !important;
  margin: auto !important;
  border-radius: 10px;
  background: rgb(255, 255, 255) !important;
}

.btn_style {
  font-size: 16px;
  font-weight: 600;
  padding: 10px 16px;
}

.bottom_btn_style {
  width: 120px;
  height: 40px;
}

#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.body-container {
  padding-top: 0px !important;
  position: fixed;
  top: 6rem;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
</style> 